import React from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
// import { HelpIconSVG } from 's2s-svg-icons';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';

// Styles the Container
const LoginFrameContainer = styled.div`
  align-items : center;
  background-color: ${colorGrid.brand5};
  display : flex;
  //flex : 1; // NOTE : This is necessary in order to take up full container
  flex-direction : column;
  font-family : inherit;
  padding : 24px auto;
  height: calc(100vh);
  min-width: 320px;
  width: 100vw;
`;

const ImageArea = styled.div`
  margin-bottom : 15px;
  margin-top : 9%;
  max-height : 150px;
  width: 60%;
  max-width: 420px;
  visibility: ${props => props.showAppInfo ? 'visible' : 'hidden'};

`;

const LoginText = styled.div`
  color: ${colorGrid.gray0};
  font-family: inherit;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 2px;
  line-height: 42px;
  margin-bottom : 16px;
  text-align: center; 
  visibility: ${props => props.showAppInfo ? 'visible' : 'hidden'};

  @media (max-height: 570px) {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 8px;
  };
`;

const RegSpan = styled.span`
  font-size: 14px;
  vertical-align: super;
`;

// necessary to tell forgotpw/login/username that it should not be any larger than 400px.
const ChildContainer = styled.div`
  min-width : 320px;
  width: 90%;
  max-width: 344px;
`;

const AppNameText = styled.span`
  color: ${colorGrid.gray0};
  font-family: inherit;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 42px;
  text-align: center;

  @media (max-height: 570px) {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 8px;
  };
`;

const TermsPolicyText = styled.div`
  color: ${colorGrid.gray0};
  font-family: inherit;
  font-size: 12px;
  visibility: ${({ hideTermsPolicy }) => hideTermsPolicy ? 'hidden' : 'visible'};
  line-height: 16px;
  margin-top : 40px;
  text-align: center;

  a {
    text-decoration: none;
  }
`;

const CopyrightText = styled.div`
  color: ${colorGrid.gray0};
  font-family: inherit;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;

// // const GetHelpButton = styled.button`
// //   align-items: center;
// //   background: ${colorGrid.brand5};
// //   border : 1px solid transparent;
// //   border-radius: 4px;
// //   color: ${colorGrid.gray0};
// //   display: flex;
// //   font-size: 12px;
// //   justify-content : space-between;
// //   line-height: 24px;
// //   padding : 8px 16px;
// //   text-align: center;
// //   margin-top: 16px; // Added after tom code review :D
// //   outline : none;

// //   &:hover {
// //     background: ${colorGrid.brand7};
// //   };

// //   &:focus { 
// //     outline : ${colorGrid.blue5};
// //     /* box shadow exists on all s2s form elements is necessary to indicate active state and override default browser settings. Color value is a colorGrid value in rgba format with .6 opacity */
// //     -webkit-box-shadow: 0px 0px 0px 2px rgba(34,138,230,0.6);
// //     -moz-box-shadow: 0px 0px 0px 2px rgba(34,138,230,0.6);
// //     box-shadow: 0px 0px 0px 2px rgba(34,138,230,0.6);
// //   };

//   &:active {
//     outline : none;
//     -webkit-box-shadow: none;
//     -moz-box-shadow: none;
//     box-shadow : none;
//   };
// `;

const LoginFrame = (props) => {
  const currentYear = new Date().getFullYear().toString();
  // console.log('props.imagesource', props.imageSource);

  const getTermsPolicy = () => {
    const termsLink = {
      title: getIntlText(props.intl, 'LOGINFRAME-TERMS-TEXT', "Terms of Use"),
      href: "https://www.star2star.com/applications-terms-of-use"
    };

    const policyLink = {
      title: getIntlText(props.intl, 'LOGINFRAME-POLICY-TEXT', "Privacy Policy"),
      href: "http://www.star2star.com/privacy-policy"
    };
    
    const textTermsPolicy = getIntlText(props.intl, 'LOGINFRAME-TERMS-POLICY-TEXT', 
      "By Signing in to this app, you agree to the Terms of Use and acknowledge the Privacy Policy")
      .replace('LOGINFRAME-TERMS-TEXT', '%')
      .replace('LOGINFRAME-POLICY-TEXT', '')
      .split('%');
     
    return (<div>{textTermsPolicy[0]} <a href={termsLink.href}>
      {termsLink.title}</a> {textTermsPolicy[1]} <a href={policyLink.href}>{policyLink.title}</a></div>);
  };


  return (
    <LoginFrameContainer className="LoginFrameContainer">
      <ImageArea className="ImageArea" showAppInfo={props.showAppInfo} >
        <img alt={"Company Logo"} src={props.imageSource} style={{ maxWidth: '100%' }} />
      </ImageArea>
      <LoginText showAppInfo={props.showAppInfo} className="LoginText" >
        {props.isChangePasswordScreen ? getIntlText(props.intl, 'LOGINFRAME-CHANGE-PASSWORD-TEXT', 'Change password for ') : getIntlText(props.intl, 'LOGINFRAME-LOGIN-TEXT', 'Log in to ')}
        <AppNameText className="AppName">
          {props.appName}
          <RegSpan>&reg;</RegSpan>
        </AppNameText>
      </LoginText>
      <ChildContainer className="ChildContainer">
        {props.children}
      </ChildContainer>
      <TermsPolicyText  className="TermsPolicyText"
        hideTermsPolicy={props.hideTermsPolicy}>
        {getTermsPolicy()}
      </TermsPolicyText>
      <CopyrightText className="CopyrightText" >
        {`© 2006 - 
          ${currentYear}
          ${props.companyName}.
          ${getIntlText(props.intl, 'LOGINFRAME-ALL-RIGHTS-RESERVED', '  All rights reserved.')}`}
      </CopyrightText>
    </LoginFrameContainer >
  );
};

LoginFrame.propTypes = {
  appName: PropTypes.string,
  companyName: PropTypes.string,
  hideTermsPolicy: PropTypes.bool,
  cbGetHelp: PropTypes.func,
  imageSource: PropTypes.string,
  isChangePasswordScreen: PropTypes.bool,
  showAppInfo: PropTypes.bool,
  intl: PropTypes.object,
};

LoginFrame.defaultProps = {
  appName: "StarMessenger",
  companyName: "Star2Star",
  cbGetHelp: () => { console.log('default function for cbGethelp '); },
  imageSource: "",
  isChangePasswordScreen: false,
  hideTermsPolicy: false,
  showAppInfo: true,
};

export default injectIntl(LoginFrame);
